import { Link } from 'gatsby';
import NavButtons from 'components/Software/Windows/NavButtons';
import ForumBox from 'components/Software/Windows/Sighthound/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};